//App
import { CountyApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const countyApi: CountyApiType = {
  get: (value) => apiClient.get(endPoints.county.get(value)),
  getCountiesView: (payload) =>
    apiClient.get(endPoints.county.getCountiesView(), payload),
  searchCounties: (payload) =>
    apiClient.post(endPoints.county.searchCounties(), payload),
  save: (payload) => apiClient.post(endPoints.county.save(), payload),
  delete: (value) => apiClient.delete(endPoints.county.delete(value)),
  activate: (value) => apiClient.post(endPoints.county.activate(value)),
};

export default countyApi;
